import {animateBiomes, applyBiomes, materials, oceanMaterial} from './biomes';

const THREE = window.THREE,
    ImprovedNoise = window.ImprovedNoise();

export default class Planet extends THREE.Mesh {
    constructor({
        radius,
        widthSegments,
        heightSegments,
        ...noiseProps
    }) {
        const geometry = new NoiseSphereGeometry(radius, widthSegments, heightSegments, noiseProps),
            biomes = applyBiomes(geometry),
            oceanGeometry = new THREE.SphereGeometry(radius, widthSegments, heightSegments),
            ocean = new THREE.Mesh(oceanGeometry, oceanMaterial);

        super(geometry, materials);
        this.add(...biomes, ocean);

        this.animate = animateBiomes;
    }
}

class NoiseSphereGeometry extends THREE.SphereGeometry {
    constructor(radius, widthSegments, heightSegments, {seed, noiseWidth, noiseHeight}) {
        super(radius, widthSegments, heightSegments);
        const getNoise = (vertice) => ImprovedNoise.noise(
                seed + vertice.x / noiseWidth,
                seed + vertice.y / noiseWidth,
                seed + vertice.z / noiseWidth
            ),
            noiseMap = this
                .vertices
                .map(getNoise),
            noiseMax = Math.max(...noiseMap),
            noiseMin = -Math.min(...noiseMap);
        for (const v in this.vertices) {
            if (noiseMap[v] > 0) {
                this
                    .vertices[v]
                    .elevation = noiseMap[v] / noiseMax;
            } else {
                this
                    .vertices[v]
                    .elevation = noiseMap[v] / noiseMin;
            }
            this
                .vertices[v]
                .multiplyScalar(1 + this.vertices[v].elevation * noiseHeight / radius);
        }
    }
}


// WEBPACK FOOTER //
// ./src/scene/planet.js